"use client";

import { useEffect, useState } from "react";
import useStore from "@/store/useStore";
import Image from "next/image";
import FadeTransition from "@/components/ui/fade-transition";

export default function AuthProvider({ children }) {
  const [isReady, setIsReady] = useState(false);
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    console.log("🔄 [AuthProvider] Starting initialization");

    let isMounted = true;

    const initializeAuth = async () => {
      try {
        // Get store state
        const store = useStore.getState();

        // Initialize auth if available
        if (store.initialize) {
          console.log("🔄 [AuthProvider] Calling store initialize");
          await store.initialize();
        }

        if (isMounted) {
          console.log("✅ [AuthProvider] Auth initialization complete");

          // Start fade out
          setShowLoading(false);

          // Complete after fade
          setTimeout(() => {
            if (isMounted) {
              setIsReady(true);
            }
          }, 300);
        }
      } catch (error) {
        console.error("❌ [AuthProvider] Auth initialization failed:", error);

        if (isMounted) {
          // Still proceed with app loading
          setShowLoading(false);
          setTimeout(() => {
            if (isMounted) {
              setIsReady(true);
            }
          }, 300);
        }
      }
    };

    // Small delay to ensure store is ready
    const timer = setTimeout(() => {
      initializeAuth();
    }, 100);

    return () => {
      isMounted = false;
      clearTimeout(timer);
    };
  }, []);

  // Show loading until ready
  if (!isReady) {
    return (
      <FadeTransition show={showLoading}>
        <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
          <div className="animate-pulse">
            <Image
              src="/logos/beta/purple.svg"
              alt="Qensa Logo"
              width={200}
              height={50}
              priority
            />
          </div>
        </div>
      </FadeTransition>
    );
  }

  return children;
}
